import { NgModule } from '@angular/core';

import {CardsComponent} from "@app/cards/cards.component";
import {CardComponent} from "@app/card/card.component";
import {SkeletonCardComponent} from "@app/skeleton-card/skeleton-card.component";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {AngularSvgIconModule} from "angular-svg-icon";
import { RouterModule } from '@angular/router';
import { CdnPipe } from '@app/cdn.pipe';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    NgOptimizedImage,
    SkeletonCardComponent,
    CardsComponent,
    CardComponent,
    RouterModule,
    CdnPipe
  ],
  exports: [
    CardsComponent,
    CardComponent,
    SkeletonCardComponent
  ]
})
export class ComponentsModule { }
